if (!window.__TCS__) {
  window.__TCS__ = {
    MONTHS: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    QUOTES: [
      {
        "quote": "You’re the jazz version of TNT",
        "date": "2013-09-23"
      },
      {
        "quote": "People think you’re a dog and I’m an old woman",
        "date": "2014-05-22"
      },
      {
        "quote": "Don’t text my butt",
        "date": "2015-02-15"
      },
      {
        "quote": "I think I’m going to wait a while just for procrastination’s sake",
        "date": "2015-06-25"
      },
      {
        "quote": "Wearing pants is a bummer",
        "date": "2015-07-28"
      },
      {
        "quote": "I don’t want to hear anything else about this cat butt pinball machine!",
        "date": "2015-11-22"
      },
      {
        "quote": "Butt licking is happening somewhere, I’m sure",
        "date": "2016-01-17"
      },
      {
        "quote": "I smelled his poop and it didn’t smell like vinegar",
        "date": "2016-03-12"
      },
      {
        "quote": "I feel suspicion about everything",
        "date": "2016-04-11"
      },
      {
        "quote": "I want what I don’t want and I don’t want what I want",
        "date": "2016-09-05"
      },
      {
        "quote": "The people at Poison Control are so nice!",
        "date": "2017-01-30"
      },
      {
        "quote": "You’re a radioactive mastiff",
        "date": "2017-04-30"
      },
      {
        "quote": "You’re not always right, but you’re always right more than me",
        "date": "2017-08-24"
      },
      {
        "quote": "Are you calling a plumber on your spoon?",
        "date": "2018-05-18"
      },
      {
        "quote": "I only know one Kip so everything he does is a Kip thing to do",
        "date": "2022-10-24"
      },
      {
        "quote": "You’re my invisible watermelon",
        "date": "2022-10-24"
      },
      {
        "quote": "You’re my butt-curtain",
        "date": "2022-10-27"
      },
      {
        "quote": "My poops are fast",
        "date": "2023-01-26"
      },
      {
        "quote": "My farts don’t make me sick, ok?!?",
        "date": "2023-01-31"
      },
      {
        "quote": "The world of horses is very complex",
        "date": "2023-02-05"
      },
      {
        "quote": "I’d rather be cold than accidentally die",
        "date": "2023-04-05"
      },
      {
        "quote": "I’m very hearable",
        "date": "2023-04-12"
      },
      {
        "quote": "We can’t just walk around in nature anymore looking for things that look like penises",
        "date": "2023-04-24"
      },
      {
        "quote": "Have you ever heard of burnt cheese? It’s worth dying for.",
        "date": "2023-04-29"
      },
      {
        "quote": "The underthing is... there",
        "date": "2023-05-19"
      },
      {
        "quote": "That hotdog tells me no",
        "date": "2023-05-21"
      },
      {
        "quote": "Birds are animals, right?",
        "date": "2023-05-25"
      },
      {
        "quote": "I don’t know if it’s a famous Swedish cow",
        "date": "2023-05-31"
      },
      {
        "quote": "I feel like I’m in the Truman Show or something",
        "date": "2023-06-01"
      },
      {
        "quote": "I rub it all over my body so I smell like bones",
        "date": "2023-06-06"
      },
      {
        "quote": "Words are not my friend",
        "date": "2023-06-07"
      },
      {
        "quote": "There’s a saying that goes… actually, I don’t know the saying",
        "date": "2023-06-14"
      },
      {
        "quote": "I just wanna run but I don’t know how to",
        "date": "2023-06-15"
      },
      {
        "quote": "She is like a raccoon… a murderous raccoon",
        "date": "2023-06-17"
      },
      {
        "quote": "All chickens are real",
        "date": "2023-06-17"
      },
      {
        "quote": "The turtle is working for me",
        "date": "2023-07-04"
      },
      {
        "quote": "Don’t throw me under the shoe bus!",
        "date": "2023-07-05"
      },
      {
        "quote": "I’m soft, see? Soft and beefy.",
        "date": "2023-07-07"
      },
      {
        "quote": "My brain can remember all the useless stuff, like the turtle drawings",
        "date": "2023-07-09"
      },
      {
        "quote": "I’m like a fat maniac",
        "date": "2023-07-16"
      },
      {
        "quote": "Their poop smell stabbed my brain",
        "date": "2023-07-26"
      },
      {
        "quote": "It looks very colorful with the colors",
        "date": "2023-07-29"
      },
      {
        "quote": "GIRL SPERM!",
        "date": "2023-08-06"
      },
      {
        "quote": "What is this, National Geographic?",
        "date": "2023-08-10"
      },
      {
        "quote": "Is it an ass watching night?",
        "date": "2023-08-27"
      },
      {
        "quote": "You don’t want to cook a steak at midnight. You’re going to attract predators.",
        "date": "2023-08-30"
      },
      {
        "quote": "I’ve heard of camel milk but I’ve never heard of donkey milk",
        "date": "2023-08-30"
      },
      {
        "quote": "Don’t look a gift horse-dog in the mouth",
        "date": "2023-09-03"
      },
      {
        "quote": "He only eats what he finds in garbage cans",
        "date": "2023-09-03"
      },
      {
        "quote": "The climbing seal gets the fish",
        "date": "2023-09-10"
      },
      {
        "quote": "I cannot imagine that shrinking genitals are good for the human race",
        "date": "2023-09-19"
      },
      {
        "quote": "It’s not like we can go up to George Washington and be like ‘Dude, what’s the deal?’",
        "date": "2023-09-20"
      },
      {
        "quote": "I keep pork rinds around because they’re fun",
        "date": "2023-09-20"
      },
      {
        "quote": "Vaginas have seasons",
        "date": "2023-09-21"
      },
      {
        "quote": "Are they a cannibal if they only did it once?",
        "date": "2023-09-21"
      },
      {
        "quote": "If a cannibal gets me then so be it",
        "date": "2023-09-26"
      },
      {
        "quote": "Not high quality vacuuming, just gettin’ up dust bunnies",
        "date": "2023-09-28"
      },
      {
        "quote": "We learned that out the hard way",
        "date": "2023-10-04"
      },
      {
        "quote": "Maybe we need to sacrifice the donkey",
        "date": "2023-10-04"
      },
      {
        "quote": "It’s not like you’re a professor of the German mafia",
        "date": "2023-10-05"
      },
      {
        "quote": "He’s got Korean-Hitler’s birthday",
        "date": "2023-10-05"
      },
      {
        "quote": "Human meat. Mmm.",
        "date": "2023-10-08"
      },
      {
        "quote": "To my knowledge, Taylor Swift is not a bear murderer",
        "date": "2023-10-12"
      },
      {
        "quote": "I’m on a cannibal roll",
        "date": "2023-10-12"
      },
      {
        "quote": "You can smell your own butt",
        "date": "2023-10-14"
      },
      {
        "quote": "Show me your pancreas!",
        "date": "2023-10-16"
      },
      {
        "quote": "Like, in history, who was super fat?",
        "date": "2023-10-16"
      },
      {
        "quote": "We’re not done until we’re finished!",
        "date": "2023-10-20"
      },
      {
        "quote": "I. AM. SPARTA!!!",
        "date": "2023-10-21"
      },
      {
        "quote": "Is my butt ethical?",
        "date": "2023-10-23"
      },
      {
        "quote": "I’m ready to go buy some onions. I feel like that’s the Germans’ first line of defense.",
        "date": "2023-10-23"
      },
      {
        "quote": "I didn’t allow myself much time to rest ’cause, you know, bacon",
        "date": "2023-10-23"
      },
      {
        "quote": "Rocks are gluten free",
        "date": "2023-10-27"
      },
      {
        "quote": "I have neck for days",
        "date": "2023-11-01"
      },
      {
        "quote": "Hey, look at me! I’m on a ball!",
        "date": "2023-11-01"
      },
      {
        "quote": "All these motherfuckers here have recessed mandibles",
        "date": "2023-11-01"
      },
      {
        "quote": "I am gonna be the cougar of Hollywood",
        "date": "2023-11-03"
      },
      {
        "quote": "I can’t get the onion smell out of my brain",
        "date": "2023-11-06"
      },
      {
        "quote": "You don’t want garlic in your butthole",
        "date": "2023-11-07"
      },
      {
        "quote": "You grow up and you become a PMS monster",
        "date": "2023-11-08"
      },
      {
        "quote": "My poops aren’t perfect",
        "date": "2023-11-10"
      },
      {
        "quote": "Let’s just spray cancer all over your face",
        "date": "2023-11-13"
      },
      {
        "quote": "Maybe we shouldn’t have another baby. Maybe we should just die.",
        "date": "2023-11-18"
      },
      {
        "quote": "I’m putting my bacon foot down",
        "date": "2023-11-19"
      },
      {
        "quote": "I guess cannibals are also carnivores",
        "date": "2023-11-19"
      },
      {
        "quote": "Germany Schmermany",
        "date": "2023-11-20"
      },
      {
        "quote": "The natural progression from keto to carnivore to cannibal",
        "date": "2023-11-22"
      },
      {
        "quote": "I only have eyes for my meat",
        "date": "2023-11-28"
      },
      {
        "quote": "Don’t shake the angry lady",
        "date": "2023-11-30"
      },
      {
        "quote": "20 year olds are not solid adults",
        "date": "2023-11-30"
      },
      {
        "quote": "At what age do we become responsible for our own fingers?",
        "date": "2023-12-01"
      },
      {
        "quote": "I’m really hoping that soon my moons come back",
        "date": "2023-12-03"
      },
      {
        "quote": "I always like when men cry. I think it’s nice.",
        "date": "2023-12-04"
      },
      {
        "quote": "I think I’ve hit my fat limit",
        "date": "2023-12-05"
      },
      {
        "quote": "No more daytime fish for you",
        "date": "2023-12-07"
      },
      {
        "quote": "I could be wrong but I think my moons are coming back stronger",
        "date": "2023-12-07"
      },
      {
        "quote": "I’ve gotta go cook midnight bacon",
        "date": "2023-12-10"
      },
      {
        "quote": "Don’t spray the cops with pesticides",
        "date": "2023-12-11"
      },
      {
        "quote": "Oh, meth",
        "date": "2023-12-13"
      },
      {
        "quote": "The Baroness of Bacon would be a good title for me",
        "date": "2023-12-14"
      },
      {
        "quote": "I would rather over red-flag than under red-flag",
        "date": "2023-12-22"
      },
      {
        "quote": "I know you don’t believe in this stuff but listen to me",
        "date": "2023-12-23"
      },
      {
        "quote": "Such is life as me",
        "date": "2023-12-25"
      },
      {
        "quote": "I don’t know if the berries growl",
        "date": "2024-01-02"
      },
      {
        "quote": "Dying by a weird Swedish hurricane sounds preferable",
        "date": "2024-01-02"
      },
      {
        "quote": "I don’t have easy access to good quality bones",
        "date": "2024-01-05"
      },
      {
        "quote": "Being a mediocre person can be exhausting",
        "date": "2024-01-06"
      },
      {
        "quote": "I could have been a Swedish midwife",
        "date": "2024-01-11"
      },
      {
        "quote": "If you can’t taste it, it’s not gross",
        "date": "2024-01-16"
      },
      {
        "quote": "People like us can’t afford bunkers. We have to live on the surface.",
        "date": "2024-01-18"
      },
      {
        "quote": "I hope the percentage of my brain that’s made of Doritos is lower than it is",
        "date": "2024-01-24"
      },
      {
        "quote": "All these rich guys trying to make me eat bugs",
        "date": "2024-01-25"
      },
      {
        "quote": "I’ve gotta cut back on jelly",
        "date": "2024-01-27"
      },
      {
        "quote": "My uterus hurted",
        "date": "2024-01-28"
      },
      {
        "quote": "I’m no Keanu Reeves",
        "date": "2024-02-01"
      },
      {
        "quote": "All hail the great sky sperm",
        "date": "2024-02-01"
      },
      {
        "quote": "Jesus take the beef-wheel",
        "date": "2024-02-02"
      },
      {
        "quote": "I’m ready to start paying our rent in gold",
        "date": "2024-02-12"
      },
      {
        "quote": "Gort will absolutely be playing with bones",
        "date": "2024-02-16"
      },
      {
        "quote": "I’ve just been sitting here thinking about robots",
        "date": "2024-02-28"
      },
      {
        "quote": "If any cereal tastes like balls, it’s probably Grape Nuts",
        "date": "2024-03-07"
      },
      {
        "quote": "I gotta leave but I can’t stop eating pork rinds",
        "date": "2024-03-07"
      },
      {
        "quote": "I would milk my own goats",
        "date": "2024-03-19"
      },
      {
        "quote": "We do poop wrong",
        "date": "2024-03-21"
      },
      {
        "quote": "Joke’s on us, we’re eating pee pee fish",
        "date": "2024-03-22"
      },
      {
        "quote": "Obviously, murderers are worse than cats",
        "date": "2024-03-27"
      },
      {
        "quote": "There’s not very much meat on the elbow",
        "date": "2024-04-02"
      },
      {
        "quote": "I probably broke tradition which is fine because I’m not Chinese",
        "date": "2024-04-10"
      },
      {
        "quote": "They want society to be like... doop, doop, doop",
        "date": "2024-05-02"
      },
      {
        "quote": "I want to understand smoked meat",
        "date": "2024-05-04"
      },
      {
        "quote": "Can’t trust living creatures",
        "date": "2024-05-11"
      },
      {
        "quote": "My brain just does stuff. I never know what it’s doing.",
        "date": "2024-05-11"
      },
      {
        "quote": "Ah, the stiffness of clean",
        "date": "2024-05-16"
      },
      {
        "quote": "If it wasn’t for that one drunk hedgehog…",
        "date": "2024-05-25"
      },
      {
        "quote": "Aaahhh! Library book.",
        "date": "2024-05-25"
      },
      {
        "quote": "I could always make eggs and bacon",
        "date": "2024-05-26"
      },
      {
        "quote": "Blow hard and wipe well, young one",
        "date": "2024-05-26"
      },
      {
        "quote": "Maybe there’s something about potatoes and thyroids I don’t understand?",
        "date": "2024-05-29"
      },
      {
        "quote": "I’ll be your fish friend",
        "date": "2024-05-30"
      },
      {
        "quote": "I feel inappropriately pregnant",
        "date": "2024-05-31"
      },
      {
        "quote": "I just feel like I don’t know what hockey teams need",
        "date": "2024-06-12"
      },
      {
        "quote": "An hour of the internet can do no good",
        "date": "2024-06-12"
      },
      {
        "quote": "I don’t feel very legendary",
        "date": "2024-06-13"
      },
      {
        "quote": "What am I? Where am I? What is this? What the fuck is happening?",
        "date": "2024-06-14"
      },
      {
        "quote": "I think it’s a lot easier to replace teeth than eyes",
        "date": "2024-06-16"
      },
      {
        "quote": "How is it this hard to be this bad at life?",
        "date": "2024-06-17"
      },
      {
        "quote": "The common response of maniacs: Shrug",
        "date": "2024-06-19"
      },
      {
        "quote": "I’m peeing in the forest",
        "date": "2024-06-21"
      },
      {
        "quote": "Tick stuff will fuck you up",
        "date": "2024-06-21"
      },
      {
        "quote": "I feel like an old dinosaur that’s pregnant",
        "date": "2024-06-21"
      },
      {
        "quote": "That’s Dr Carol’s professional opinion",
        "date": "2024-06-22"
      },
      {
        "quote": "Do hamsters have lips?",
        "date": "2024-06-23"
      },
      {
        "quote": "That was an emotional emotion storm",
        "date": "2024-06-23"
      },
      {
        "quote": "Last time I thought I heard a cat, a baby was being vaccinated",
        "date": "2024-06-23"
      },
      {
        "quote": "Gassy is when gas comes out. Poopy is when poop comes out.",
        "date": "2024-06-23"
      },
      {
        "quote": "I farted in this area, just to warn you",
        "date": "2024-06-24"
      },
      {
        "quote": "You’re not having cake at bedtime. That’s not how cake works.",
        "date": "2024-06-24"
      },
      {
        "quote": "The ghost of your mom making posts on Facebook",
        "date": "2024-06-24"
      },
      {
        "quote": "Human meat is on the chopping block",
        "date": "2024-06-25"
      },
      {
        "quote": "Alright coconut oil, work your magic",
        "date": "2024-06-25"
      },
      {
        "quote": "I’m about to whip out the internet",
        "date": "2024-06-26"
      },
      {
        "quote": "Even bus drivers make mistakes sometimes",
        "date": "2024-06-26"
      },
      {
        "quote": "You don’t age well in prison",
        "date": "2024-06-26"
      },
      {
        "quote": "I can’t break my tomato habit",
        "date": "2024-06-27"
      },
      {
        "quote": "We can definitely eat cobalt",
        "date": "2024-06-28"
      },
      {
        "quote": "Buckle in buck-o, it’s gonna be a long life",
        "date": "2024-06-29"
      },
      {
        "quote": "Sweden: The land of garbage bananas",
        "date": "2024-06-30"
      },
      {
        "quote": "I feel like he was puking truth all over me",
        "date": "2024-06-30"
      },
      {
        "quote": "Citizen’s arrest! Your house is too messy!",
        "date": "2024-07-01"
      },
      {
        "quote": "I’m saving your testicles for you, ok?!?",
        "date": "2024-07-05"
      },
      {
        "quote": "I did not just call your baby weird, I promise",
        "date": "2024-07-08"
      },
      {
        "quote": "I’m gonna be outside in the grass clipping my toenails like a classy lady",
        "date": "2024-07-08"
      },
      {
        "quote": "I think about you dying sometimes",
        "date": "2024-07-09"
      },
      {
        "quote": "I’ve been in headache jail the whole day",
        "date": "2024-07-14"
      },
      {
        "quote": "Can I bury my placenta in your yard?",
        "date": "2024-07-16"
      },
      {
        "quote": "What’s something you’re grateful for? Arms?",
        "date": "2024-07-19"
      },
      {
        "quote": "I’m leading with my uterus nowadays",
        "date": "2024-07-19"
      },
      {
        "quote": "Let me see your nostrils",
        "date": "2024-07-19"
      },
      {
        "quote": "Fascism icebergs suck",
        "date": "2024-07-20"
      },
      {
        "quote": "Maybe all kids are trolls?",
        "date": "2024-07-20"
      },
      {
        "quote": "Do I look like somebody that would have a bone saw?",
        "date": "2024-07-20"
      },
      {
        "quote": "I don’t want a tree house but I’d love to live in the forest",
        "date": "2024-07-24"
      },
      {
        "quote": "We’re walking into a Gus situation",
        "date": "2024-08-01"
      },
      {
        "quote": "I’m allergic to drama",
        "date": "2024-08-01"
      },
      {
        "quote": "I have to pay $180 for some hot dogs",
        "date": "2024-08-04"
      },
      {
        "quote": "I feel like I’m sealing my fate to get eaten by a bear",
        "date": "2024-08-04"
      },
      {
        "quote": "Your brain’s not gonna have to overcome all the Hot Pockets",
        "date": "2024-08-05"
      },
      {
        "quote": "Sorry about my butt",
        "date": "2024-08-05"
      },
      {
        "quote": "I don’t want to punch people with my baby. No, thank you.",
        "date": "2024-08-06"
      },
      {
        "quote": "Sorry, bird. I sacrificed you to my child.",
        "date": "2024-08-06"
      },
      {
        "quote": "I have to watch a video about roasting bones",
        "date": "2024-08-08"
      },
      {
        "quote": "When’s the last time you heard about the Jeff Bezos library of Michigan?",
        "date": "2024-08-12"
      },
      {
        "quote": "My refried beans betrayed me",
        "date": "2024-08-12"
      },
      {
        "quote": "My dad called me Turkey… Turkey Legs",
        "date": "2024-08-14"
      },
      {
        "quote": "Tim Burton? The weird guy with the movies?",
        "date": "2024-08-14"
      },
      {
        "quote": "Poison is kind of tasty",
        "date": "2024-08-17"
      },
      {
        "quote": "We have reached our cannibal quota",
        "date": "2024-08-17"
      },
      {
        "quote": "How many people do you need to have a cabal?",
        "date": "2024-08-22"
      },
      {
        "quote": "I inflated parachute pants in my mind",
        "date": "2024-08-25"
      },
      {
        "quote": "Go enjoy your date with Sharkwoman",
        "date": "2024-08-25"
      },
      {
        "quote": "All grown-ups came from babies",
        "date": "2024-08-29"
      },
      {
        "quote": "I just spit on your face. I apologize.",
        "date": "2024-09-02"
      },
      {
        "quote": "Maybe it was an albino squirrel?",
        "date": "2024-09-02"
      },
      {
        "quote": "Did you just clone yourself in my uterus?",
        "date": "2024-09-07"
      },
      {
        "quote": "It’s like cucumber city. Gross.",
        "date": "2024-09-07"
      },
      {
        "quote": "Nobody wants to be associated with a child duck",
        "date": "2024-09-08"
      },
      {
        "quote": "I never joke about thermoses",
        "date": "2024-09-09"
      },
      {
        "quote": "Do dolphins breastfeed?",
        "date": "2024-09-18"
      },
      {
        "quote": "Kevin. Robin. Kevin. Robin. Kevin. Robin. Do you hear it?",
        "date": "2024-09-20"
      },
      {
        "quote": "Why do any of us have butts?",
        "date": "2024-09-29"
      },
      {
        "quote": "Kevin Costner. He’s real. As far as I know.",
        "date": "2024-10-02"
      },
      {
        "quote": "It feels like I’m wrestling a duck",
        "date": "2024-10-03"
      },
      {
        "quote": "Quadmester? Is that a word?",
        "date": "2024-10-04"
      },
      {
        "quote": "I’m an ape, thank you very much",
        "date": "2024-10-05"
      },
      {
        "quote": "I swear I’ll never poison your cookies",
        "date": "2024-10-12"
      },
      {
        "quote": "Your brain always goes to the anus",
        "date": "2024-10-12"
      },
      {
        "quote": "Kevins come and Kevins go",
        "date": "2024-10-12"
      },
      {
        "quote": "Wolfgang595 says ‘I’m a guy named Wolfgang’",
        "date": "2024-10-12"
      },
      {
        "quote": "Not very many people wrote poems about things I’ve done",
        "date": "2024-10-14"
      },
      {
        "quote": "Wood is important to me. It’s an EMF thing.",
        "date": "2024-10-15"
      },
      {
        "quote": "Mushrooms are fun, aren’t they?",
        "date": "2024-10-15"
      },
      {
        "quote": "We sat on Kevin for several days",
        "date": "2024-10-16"
      },
      {
        "quote": "I have a low fish threshold",
        "date": "2024-10-17"
      },
      {
        "quote": "Nowhere in nature do cows drink beer",
        "date": "2024-10-19"
      },
      {
        "quote": "You’re a weird lady waving this smelly thing in my face",
        "date": "2024-10-20"
      },
      {
        "quote": "It’s like a suprise Paul",
        "date": "2024-10-20"
      },
      {
        "quote": "I am incapable of french-toasting tonight",
        "date": "2024-11-04"
      },
      {
        "quote": "The guy was from the American Eye-People’s Association",
        "date": "2024-11-08"
      },
      {
        "quote": "I don’t like when they just take X-rays for fun",
        "date": "2024-11-12"
      },
      {
        "quote": "I feel like that’s where we’re headed. Into butthole town.",
        "date": "2024-11-16"
      },
      {
        "quote": "Oh, that wily Keith",
        "date": "2024-11-16"
      },
      {
        "quote": "I think making sense is overrated",
        "date": "2024-11-17"
      },
      {
        "quote": "She wasn’t giving ball pit energy",
        "date": "2024-11-21"
      },
      {
        "quote": "He is a full body sneezer",
        "date": "2024-11-24"
      },
      {
        "quote": "Socks don’t go in poop",
        "date": "2024-11-24"
      },
      {
        "quote": "Diapers and raincoats are different things",
        "date": "2024-11-25"
      },
      {
        "quote": "Ooh, I can see your hidden lair",
        "date": "2024-11-29"
      },
      {
        "quote": "I feel like your dad has a redneck soul",
        "date": "2024-11-29"
      },
      {
        "quote": "Can’t you just like paint a bunny or something?",
        "date": "2024-12-01"
      },
      {
        "quote": "I would need some sort of promise or something from Jesus Christ",
        "date": "2024-12-01"
      },
      {
        "quote": "What am I gonna do? Fly to Hawaii and take a survey?",
        "date": "2024-12-04"
      },
      {
        "quote": "I’m just saying, our pineal glands are not calcified",
        "date": "2024-12-04"
      },
      {
        "quote": "Don’t let me forget my face",
        "date": "2024-12-05"
      },
      {
        "quote": "My brain goblins make me read bad",
        "date": "2024-12-05"
      },
      {
        "quote": "Why is your butt so cold? What a mystery.",
        "date": "2024-12-07"
      },
      {
        "quote": "I’m not gonna eat peaches in the bathroom",
        "date": "2024-12-16"
      },
      {
        "quote": "I am the worst conspiracy theorist",
        "date": "2024-12-19"
      },
      {
        "quote": "I feel like your attention span is gonna be like the size of a walnut",
        "date": "2024-12-20"
      },
      {
        "quote": "We’re smarter than a cat but less smarter than a sea turtle",
        "date": "2024-12-21"
      },
      {
        "quote": "There’s probably poop all over that starfish",
        "date": "2024-12-21"
      },
      {
        "quote": "Am I peeing? What is happening?",
        "date": "2024-12-23"
      },
      {
        "quote": "You can’t be stealthy if you’re playing TV shows in German",
        "date": "2024-12-26"
      },
      {
        "quote": "We can almost swim in Elon Musk’s rice pile",
        "date": "2024-12-27"
      },
      {
        "quote": "Will you keep your tooth to yourself?",
        "date": "2025-01-03"
      },
      {
        "quote": "Let’s see if the internet lied to me",
        "date": "2025-01-08"
      },
      {
        "quote": "Well, grass doesn’t run away from you",
        "date": "2025-01-09"
      },
      {
        "quote": "I wonder if I could ferment my own breast milk?",
        "date": "2025-01-16"
      },
      {
        "quote": "I want this child motivated to activate",
        "date": "2025-01-17"
      },
      {
        "quote": "I gave birth to Loki and didn’t even know it",
        "date": "2025-01-17"
      },
      {
        "quote": "Babies are innocent, sweet balls of potential",
        "date": "2025-01-18"
      },
      {
        "quote": "So I didn’t get to kill Jesus and now I’m being blamed for going the wrong way",
        "date": "2025-01-19"
      },
      {
        "quote": "Whales are party people",
        "date": "2025-01-20"
      },
      {
        "quote": "No farting at the dinner area",
        "date": "2025-01-21"
      },
      {
        "quote": "Give me that rainbow poop",
        "date": "2025-01-25"
      },
      {
        "quote": "Baby shrimp catapult!",
        "date": "2025-01-29"
      },
      {
        "quote": "To me, Neil is a Buford",
        "date": "2025-01-30"
      },
      {
        "quote": "You’re not gonna like this but I’m gonna put breast milk up your nose",
        "date": "2025-02-16"
      },
      {
        "quote": "This German science lady you turned me into is so funny",
        "date": "2025-02-16"
      },
      {
        "quote": "Look at how snow white my lard is",
        "date": "2025-02-16"
      },
      {
        "quote": "It’s like excavating for chicken tenders",
        "date": "2025-02-21"
      },
      {
        "quote": "I guess I shouldn’t trust a baby’s judgement",
        "date": "2025-02-26"
      },
      {
        "quote": "Do magnets die?",
        "date": "2025-03-02"
      },
      {
        "quote": "You’re my fermentation lifestyle",
        "date": "2025-03-03"
      },
      {
        "quote": "I don’t think it’s great to eat random yeast",
        "date": "2025-03-04"
      },
      {
        "quote": "The internet agrees with me that my Kevin probably has the yeast",
        "date": "2025-03-04"
      },
      {
        "quote": "Why does evil exist? And why do butthole fish exist?",
        "date": "2025-03-04"
      },
      {
        "quote": "You gotta appreciate what’s appreciatable",
        "date": "2025-03-06"
      },
      {
        "quote": "Are you impressed with my bulk chocolate nuts hack?",
        "date": "2025-03-06"
      },
      {
        "quote": "I don’t want cyborg grand babies",
        "date": "2025-03-07"
      },
      {
        "quote": "Beef, bacon, or boobs? Who knows?",
        "date": "2025-03-08"
      },
      {
        "quote": "You cannot divorce your husband because he didn’t like your penis shoes",
        "date": "2025-03-08"
      },
      {
        "quote": "I gotta plant those tomatoes on the full moon",
        "date": "2025-03-14"
      },
      {
        "quote": "The next time he cries, I want you to run in there and smell his butt",
        "date": "2025-03-18"
      },
      {
        "quote": "I didn’t know the Lithuanian perspective on the shoe making skills of Czechs",
        "date": "2025-03-19"
      },
      {
        "quote": "I think we have African foot shape",
        "date": "2025-03-19"
      },
      {
        "quote": "I got that good carnivore sperm",
        "date": "2025-03-20"
      },
      {
        "quote": "I’m just a sheep farmer. I just sell sheep meat.",
        "date": "2025-03-22"
      },
      {
        "quote": "It’s amazing how fast plants move",
        "date": "2025-03-22"
      },
      {
        "quote": "Those balls are so small I’m afraid you won’t be able to see them",
        "date": "2025-03-23"
      },
      {
        "quote": "Thanks for yelling ‘balls’ at my stomach for 9 months",
        "date": "2025-03-23"
      },
      {
        "quote": "You know what I mean? They’re gettin’ double turned.",
        "date": "2025-03-24"
      },
      {
        "quote": "We’ll set it on fire. You’ll be very happy.",
        "date": "2025-03-26"
      },
      {
        "quote": "Just yank. It’s what I do.",
        "date": "2025-03-26"
      },
      {
        "quote": "I guess burps aren’t the clearest form of communication",
        "date": "2025-03-26"
      },
      {
        "quote": "I just don’t want to do anything for 3 hours",
        "date": "2025-03-27"
      },
      {
        "quote": "Entertaining butt wipe",
        "date": "2025-03-30"
      },
      {
        "quote": "He throat-punched me in the thyroid",
        "date": "2025-03-30"
      },
      {
        "quote": "I feel like Daylight Savings was the first psyop",
        "date": "2025-03-30"
      },
      {
        "quote": "I’m taking things off your brain",
        "date": "2025-04-02"
      },
      {
        "quote": "You’re an oily mushroom",
        "date": "2025-04-04"
      },
      {
        "quote": "You are much more beautiful than a tomato plant",
        "date": "2025-04-05"
      },
      {
        "quote": "If they can put chips in people’s brains, I should be able to clean that bottle",
        "date": "2025-04-05"
      },
      {
        "quote": "I’m so excited that it’s toenail cutting season!",
        "date": "2025-04-05"
      },
      {
        "quote": "He gets a lot of those, like, impact farts",
        "date": "2025-04-06"
      },
      {
        "quote": "Your fascination with the dishwasher worries me",
        "date": "2025-04-06"
      },
      {
        "quote": "I’ll excite your molecules",
        "date": "2025-04-11"
      },
      {
        "quote": "It’s never fun to wake up from a nap to shit yourself",
        "date": "2025-04-11"
      },
      {
        "quote": "I’m gonna go look at the ketchup and think about it",
        "date": "2025-04-13"
      },
      {
        "quote": "I’m always thinking ‘Am I going to miscalculate some caffeine and accidentally milk myself?’",
        "date": "2025-04-13"
      },
      {
        "quote": "I wonder if I have a dominant toe?",
        "date": "2025-04-14"
      },
      {
        "quote": "I feel like that guy is brainwashed, and I mean that in a loving way",
        "date": "2025-04-19"
      },
      {
        "quote": "The whole world needs guinea hens",
        "date": "2025-04-24"
      },
      {
        "quote": "I just think the lamb is softer than the squirrel",
        "date": "2025-04-25"
      },
      {
        "quote": "I hope I got the geometry on my shoes right",
        "date": "2025-05-01"
      },
      {
        "quote": "I’m the master of my own butt washing",
        "date": "2025-05-02"
      },
      {
        "quote": "What does the CIA want me to know about Christopher Columbus?",
        "date": "2025-05-04"
      },
      {
        "quote": "Drugs crazy people up",
        "date": "2025-05-13"
      },
      {
        "quote": "Maybe turds have immunity boosting properties?",
        "date": "2025-05-17"
      },
      {
        "quote": "I know he was schizophrenic but I wonder what his zodiac sign was?",
        "date": "2025-05-17"
      },
      {
        "quote": "Twerking is a type of dancing",
        "date": "2025-05-24"
      },
      {
        "quote": "I think it’s going to require something stronger than a potato",
        "date": "2025-05-25"
      },
      {
        "quote": "Maybe one day Bill Gates will genetically modify you to be part pigeon",
        "date": "2025-05-25"
      },
      {
        "quote": "Diarrhea chicken broth",
        "date": "2025-05-30"
      },
      {
        "quote": "All these freaking whatevers can’t stop me!",
        "date": "2025-06-02"
      },
      {
        "quote": "Guess I don’t need steak to eat glasses",
        "date": "2025-06-12"
      },
      {
        "quote": "Oh my placenta",
        "date": "2025-06-19"
      },
      {
        "quote": "I really would like to clean that force of nature’s butt",
        "date": "2025-06-22"
      },
      {
        "quote": "I know what the outside of a lemon looks like",
        "date": "2025-07-09"
      },
      {
        "quote": "Oh yeah, traveler’s constipation",
        "date": "2025-07-13"
      },
      {
        "quote": "Fingers crossed for a fart",
        "date": "2025-07-16"
      },
      {
        "quote": "There are bad poor people, they just don’t have the financial resources to hire a prostitute to extort their sisters",
        "date": "2025-07-17"
      },
      {
        "quote": "I cleaned a pot for this!",
        "date": "2025-07-20"
      },
      {
        "quote": "I won’t cash any checks my butt writes",
        "date": "2025-07-20"
      },
      {
        "quote": "Think of how much more I’d get done if I was an android",
        "date": "2025-07-25"
      },
      {
        "quote": "That’s what they call me… Ye old pungent butt",
        "date": "2025-07-28"
      },
      {
        "quote": "Why don’t you eat some meatballs instead of some toenails?",
        "date": "2025-08-10"
      },
      {
        "quote": "You thumbs up’d my brain fart",
        "date": "2025-08-11"
      },
      {
        "quote": "If you don’t have to fold someone else’s parents’ underwear, you shouldn’t have to",
        "date": "2025-08-15"
      },
      {
        "quote": "There’s gotta be a man named Crystal",
        "date": "2025-08-17"
      },
      {
        "quote": "She’s a guerrilla wheat collector",
        "date": "2025-08-22"
      },
      {
        "quote": "Sympathy howl for my mom",
        "date": "2025-08-22"
      },
      {
        "quote": "Thimble coincidences? I don’t think so.",
        "date": "2025-08-23"
      },
      {
        "quote": "I’ll be back in the future",
        "date": "2025-08-24"
      },
      {
        "quote": "Guess I’m worms in a bucket girl",
        "date": "2025-08-26"
      },
      {
        "quote": "10 is closer than brown",
        "date": "2025-08-27"
      },
      {
        "quote": "I should have been a dock worker",
        "date": "2025-09-03"
      },
      {
        "quote": "You can go. You don’t have to listen to me talk about the Amish.",
        "date": "2025-09-07"
      },
      {
        "quote": "My brain doesn’t forget unless I wanna remember and then it definitely does",
        "date": "2025-09-11"
      },
      {
        "quote": "My pants fell off and I didn’t wanna put them back on",
        "date": "2025-09-13"
      },
      {
        "quote": "Giving up those opioids or whatever’s in milk",
        "date": "2025-09-17"
      },
      {
        "quote": "Things are only cringey if you realize they’re cringey",
        "date": "2025-09-20"
      },
      {
        "quote": "We are definitely the invasivest species",
        "date": "2025-09-23"
      },
      {
        "quote": "Toes are such weird things",
        "date": "2025-09-26"
      },
      {
        "quote": "It’s hard to stab yourself safely",
        "date": "2025-09-27"
      },
      {
        "quote": "If there’s a stupid question, I’ll find it",
        "date": "2025-10-03"
      },
      {
        "quote": "No medicinal Rice Krispies Treats?",
        "date": "2025-10-08"
      },
      {
        "quote": "I’ve sold a hundred brooms, now I’m going to retire",
        "date": "2025-10-12"
      },
      {
        "quote": "I’m gonna eat ya. Please don’t kill me.",
        "date": "2025-10-16"
      },
      {
        "quote": "Beautiful guy kicking beautiful pancakes",
        "date": "2025-10-20"
      },
      {
        "quote": "I was thinking about something the ostrich-lady said",
        "date": "2025-10-23"
      },
      {
        "quote": "I think your brain seeks out penises",
        "date": "2025-10-23"
      },
      {
        "quote": "Like a good neighbor, don’t bang your gong",
        "date": "2025-10-30"
      },
      {
        "quote": "Bananas don’t get to own penises",
        "date": "2025-11-19"
      },
      {
        "quote": "I’m very proud of my penis butt",
        "date": "2025-11-20"
      },
      {
        "quote": "You guys stay here. I’ll go to the Caribbean and die.",
        "date": "2025-11-21"
      },
      {
        "quote": "I could fight 4 babies",
        "date": "2025-11-23"
      },
      {
        "quote": "Dammit! Dammit! Dammit! The kids ate all my ketchup!",
        "date": "2025-11-24"
      },
      {
        "quote": "Maybe he’s just really tied down with the buffalo?",
        "date": "2025-11-30"
      },
      {
        "quote": "Somebody look up American Sign Language for cheese",
        "date": "2025-12-02"
      }
    ]
  };
}
